<div class="page-root">
  <div class="typo-h1">{{ "booking.confirm.title" | transloco }}</div>

  @if (bookingFor) {
    <div class="labeled-text">
      <div class="label">
        <mat-icon>person</mat-icon>
        <div class="body-text-bold">{{ "appointmentSelection.selectPatient" | transloco }}</div>
      </div>

      {{ patient?.firstName }} {{ patient?.lastName }}<br/>{{ patient?.dateOfBirth }}
    </div>
  }

  @if (memoryService.locationDetailDto?.appearanceSettings?.warnOnTherapistChange && (latestAppointment &&
    latestAppointment.employeeId != appointmentSelectionService.timeSlotDto?.employeeId)) {
    <div class="hint">
      <div class="body-text hint-text">{{ "booking.confirm.therapistChangeWarning" | transloco: {latestTherapist: latestAppointment.employeeName, selectedTherapist: employeeName} }}</div>
    </div>
  }

  <div class="column">
    <div class="body-text-bold">{{ "booking.confirm.label.bookingMessage" | transloco }}</div>
    <mat-form-field subscriptSizing="dynamic">
      <textarea [formControl]="bookingMessageForm" [placeholder]="'form.placeholder.text' | transloco" matInput rows="4"></textarea>
    </mat-form-field>
  </div>

  @if (showBookingHint) {
    <div class="hint">
      <div class="body-text-bold hint-text">{{ "booking.confirm.label.bookingHint" | transloco }}</div>
      <div class="body-text hint-text">{{ bookingHint }}</div>
    </div>
  }

  @if (error) {
    <mat-error>{{ error }}</mat-error>
  }

  <div class="actions">
    <app-text-button (click)="confirm()" [text]="'booking.confirm.button' | transloco" colorVariant="primary" leadingIcon="check_circle" type="rounded"/>
    @if (mobile) {
      <app-text-button (click)="cancel()" [text]="'button.cancel' | transloco" colorVariant="outlined-neutral" leadingIcon="close" type="rounded"/>
    }
  </div>
</div>
